/* 
 * Export component file to be used on project
*/

import PaymentFooter from './PaymentFooter.js';
export default PaymentFooter;
